module.exports = __webpack_public_path__ + "img/81.3aec3639.jpg";